import React from 'react';
import styled from 'styled-components';
import Warning from '@/assets/icons/warning-alert.svg';

interface AlertComponentProps {
  children: any;
}

const ContainerBox = styled.div`
  padding: 10;
  background-color: #d5e5f0;
  border-radius: 5px;
`;

const WarningComponent = ({ children }: AlertComponentProps) => (
  <ContainerBox>
    <div
      style={{
        padding: 10,
        display: 'flex',
        alignItems: 'flex-start'
      }}
    >
      <img src={Warning} alt="Img-alert" width={20} height={20} />
      <p style={{ marginLeft: 10 }}>{children}</p>
    </div>
  </ContainerBox>
);

export default WarningComponent;
